"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var CalculatorContextInterface_1 = require("../CalculatorContextInterface");
var CalculatorNeedContactView = function () {
    var _a = (0, CalculatorContextInterface_1.useCalculatorContext)(), nickname = _a.nickname, appOrder = _a.appOrder, setNickname = _a.setNickname;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var _c = (0, react_hook_form_1.useFormContext)(), register = _c.register, errors = _c.formState.errors, setValue = _c.setValue;
    var _d = (0, react_1.useState)(""), needcontact = _d[0], setNeedcontact = _d[1];
    (0, react_1.useEffect)(function () {
        if (appOrder && appOrder.needcontact) {
            setValue("needcontact", appOrder.needcontact);
            setNeedcontact(appOrder.needcontact);
        }
    }, [appOrder]);
    return (react_1.default.createElement("div", { className: "__wrap-item" },
        react_1.default.createElement("div", { className: "__wrap-top-item" }, errors.needcontact
            ?
                react_1.default.createElement("div", { className: "__has-error" }, t("calculator.needcontact.error.emty"))
            :
                react_1.default.createElement("span", { className: "__top-notification" }, t("calculator.needcontact.input.caption"))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('__input-icon-wrap-full', errors.needcontact ? "__error" : "", (needcontact === null || needcontact === void 0 ? void 0 : needcontact.length) > 0 ? "__succeess" : "") },
            react_1.default.createElement("input", __assign({}, register("needcontact", {
                required: true,
                onChange: function (e) { return setNeedcontact(e.target.value); }
            }), { placeholder: t("calculator.needcontact.input.placeholder") })))));
};
exports.default = CalculatorNeedContactView;
